<ion-list [formGroup]="formGroup">
  <bepatient-question-title-v3
    [title]="question.label"
    [constraints]="question.constraints"
    [color]="color"
    [errors]="question.errors"
    [css]="question.css"
    [key]="question.key"
    [value]="value"
    [hasCondition]="question.hasCondition"
  >
  </bepatient-question-title-v3>
  <ion-item [ngSwitch]="question.dualKnobs">
    <ion-range
      *ngSwitchDefault
      [id]="question.key"
      [min]="question.min"
      [max]="question.max"
      [step]="question.step"
      [color]="question.color"
      [name]="question.key"
      [attr.disabled]="question.disabled || question.readonly"
      [formControlName]="question.key"
    >
      <div slot="start" class="range_start_label">{{ question.min }}</div>
      <div slot="end" class="range_end_label">{{ question.max }}</div>
    </ion-range>
    <ion-range
      *ngSwitchCase="true"
      [id]="question.key"
      [min]="question.min"
      [max]="question.max"
      [step]="question.step"
      [color]="question.color"
      [name]="question.key"
      [attr.disabled]="question.disabled || question.readonly"
      [formControlName]="question.key"
      dualKnobs="true"
    >
      <div class="bepatient__range_label" slot="start">
        {{ formGroup.value[question.key]['lower'] }}
      </div>
      <div class="bepatient__range_label" slot="end">
        {{ formGroup.value[question.key]['upper'] }}
      </div>
    </ion-range>
  </ion-item>
</ion-list>
